export const POTENTIAL_OWNERS = [
    "Afydi", "Aliado Inmobiliaria", "Banco Agrario", "Banco de Bogotá", "Banco de occidente", "BBVA", 
    "Claro", "Colpatria", "Constructora Bolívar", "Constructora Capital", "Davivienda", "Habi", 
    "Inmobiliaria Bogotá", "ITAU", "Negociación especial", "Pads", "Pichincha", "Propio", "Seguros Bolivar", 
    "Caridix Inmobiliaria", "Nitro Inmobiliaira", "LOGISTICA Y CONSULTORIA Y SERVICIOS INMOBILIARIOS LCS LTDA", 
    "red real state digital", "Casa 360", "Monserrate - Medellin", "Valor Tierra Inmobiliaria", "Tu casa.com", 
    "Inmobiliaria Integrity", "Bienes Inmobiliarios de colombia SAS.", "ADMINISTRADORA NUEVA CIUDAD LTDA", 
    "Inmobiliaria Aliadas venta", "Gestiones Inmobiliarias FT S.A.S.", "MLS Medellín"
];

export const COUNTRY_CODES = [
  { value: '+57', label: '🇨🇴 +57' },
  { value: '+1', label: '🇺🇸 +1' },
  { value: '+507', label: '🇵🇦 +507' },
  { value: '+34', label: '🇪🇸 +34' },
  { value: '+52', label: '🇲🇽 +52' },
  { value: '+44', label: '🇬🇧 +44' },
];

export const ID_TYPES = [
  { value: 'CC', label: 'Cédula de ciudadanía' },
  { value: 'CE', label: 'Cédula de extranjería' },
  { value: 'NIT', label: 'Nit' },
  { value: 'PAS', label: 'Pasaporte' },
  { value: 'TI', label: 'Tarjeta de identidad' },
];

export const ID_TYPE_MAPPING: Record<string, string> = {
  'CC': 'Cédula de ciudadanía',
  'CE': 'Cédula de extranjería',
  'NIT': 'Nit',
  'PAS': 'Pasaporte',
  'TI': 'Tarjeta de identidad',
};